import { useNavigate } from 'react-router-dom'
import { Button } from '../../../../components/button'
import { PageContainer } from '../../../../components/page-container/page-container'
import { paths } from '../../../../router/paths'

export const Welcome = () => {
  const navigate = useNavigate()

  return (
    <PageContainer>
      <div className="flex h-screen w-full flex-col items-center justify-between gap-8 px-8 py-16">
        <div className="flex justify-center py-8">
          <img
            src={
              'https://storage.googleapis.com/osb-files/dash/logo-primary.png'
            }
            alt="logo"
            className="w-80 object-cover"
          />
        </div>
        <div className="flex flex-col items-center gap-6">
          <h1 className="text-2xl font-medium">Bienvenido a DASH</h1>
          <p className="text-xs font-normal">
            Simplifica tus ventas usando ACH
          </p>
        </div>
        <div className="flex w-full flex-col items-center gap-4">
          <Button
            className="h-[55px] w-full rounded-[10px] text-xl font-semibold"
            onClick={() => navigate(paths.authentication.login)}
          >
            Iniciar sesión
          </Button>
          <Button
            onClick={() => navigate(paths.user.createUser)}
            variant="outlined"
            className="h-[55px] w-full rounded-[10px] text-xl font-semibold"
          >
            Registrarse
          </Button>
        </div>
      </div>
    </PageContainer>
  )
}
